// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__1QlrO","containerItemsCenter":"Skeleton_containerItemsCenter__32Lh8"};